/* tslint:disable */

declare var Object: any;
export interface PreguntasInterface {
  "id": number;
  "encuestaId": number;
  "tipoPreguntaId": number;
  "texto": string;
}

export class Preguntas implements PreguntasInterface {
  "id": number;
  "encuestaId": number;
  "tipoPreguntaId": number;
  "texto": string;
  constructor(data?: PreguntasInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Preguntas`.
   */
  public static getModelName() {
    return "Preguntas";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Preguntas for dynamic purposes.
  **/
  public static factory(data: PreguntasInterface): Preguntas{
    return new Preguntas(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Preguntas',
      plural: 'Preguntas',
      path: 'Preguntas',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "encuestaId": {
          name: 'encuestaId',
          type: 'number'
        },
        "tipoPreguntaId": {
          name: 'tipoPreguntaId',
          type: 'number'
        },
        "texto": {
          name: 'texto',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/shared/lb-sdk/models/Preguntas.ts